import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import StickyExploreButton from "./components/StickyExploreButton";
import StickyLeftButton from "./components/StickyLeftButton";
import AftersalesExploreService from "./components/AftersalesExploreService";

function EVHCInfo() {
    const navigate = useNavigate();

    const cars = [
        {
            name: "All New Vellfire Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/vellfire.png",
        },
        {
            name: "All New Alphard Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/alphard.png",
        },
        {
            name: "All New Kijang Innova Zenix Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/zenix.png",
        },
        {
            name: "All New Yaris Cross Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/yaris-cross.png",
        },
        {
            name: "All New BZ4X Battery EV",
            type: "Battery EV",
            image: "/assets/hybrid-model/bz4x.png",
        },
        {
            name: "New Corolla Cross Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/corolla-cross.png",
        },
        {
            name: "New Corolla Cross Hybrid EV GR Sport",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/corolla-cross-gr-sport.png",
        },
        {
            name: "New Camry Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/camry.png",
        },
        {
            name: "New Corolla Altis Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/altis.png",
        },
        {
            name: "New Veloz Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/veloz.png",
        },
        {
            name: "New Vios Hybrid EV",
            type: "Hybrid EV",
            image: "/assets/hybrid-model/vios.png",
        }
    ];

    const carSliderSettings = {
        centerMode: true,
        centerPadding: "0px",
        slidesToShow: 3,
        arrows: true,
        infinite: true,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        responsive: [
            {
            breakpoint: 768,
            settings: { slidesToShow: 1 }
            }
        ]
    };

    return (

    <div id="navbar_top">
      <Header headerTheme={'toyota-hybrid'}></Header>
      <StickyExploreButton showItem={[7,2,0,4]} stickyTheme={'hybrid-theme'} />
      <StickyLeftButton offerIndex={5} stickyTheme={'hybrid-theme'} />
      <div className="section-1 p-0 " id="section-1">
        <div>
          {/* <img
            src="assets/hybrid-health-check-desktop-banner.jpg"
            className="d-block w-100"
            alt="Slide 1"
          /> */}
          <picture>
            <source media="(max-width:640px)" srcSet="/assets/hybrid-health-check-mobile-banner.jpg" />
            <img src="/assets/hybrid-health-check-desktop-banner.jpg" alt="Toyota Hybrid Health Check" class="w-100" / >
          </picture>
        </div>
      </div>

      <div className="container-fluid p-0 mt-5" id="hybridHealthCheckSection">
        <div id="evhcMainTab">
          <div className='container'>
            <ul className="nav nav-tabs custom-nav-tabs nav-fill custom-nav-fill ms-lg-0 ms-4 me-lg-0 me-4" style={{border: 'none'}} role="tablist">
              <li className="nav-item custom-nav-item" role="presentation">
                <button
                  className={ `nav-link custom-nav-link active` }
                  id="faq_tab_1-tab"
                  onClick={() => {
                    // handleHHCMainTab('info')
                  }}
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_1"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_1"
                  aria-selected="true"
                >
                  <div className="d-flex flex-column lh-lg fw-bold menu-item">
                    <span>Hybrid Health Check Information</span>
                  </div>
                </button>
              </li>
              <li className="nav-item custom-nav-item" role="presentation">
                <button
                  className={ `nav-link custom-nav-link` }
                  id="faq_tab_2-tab"
                  onClick={() => {
                    // handleHHCMainTab('certificate')
                    navigate('/hybrid-health-check/certificate-hhc')
                  }}
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_2"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_2"
                  aria-selected="false"
                >
                  <div className="d-flex flex-column lh-lg fw-bold menu-item">
                    <span>Certificate Health Check</span>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="container px-lg-5">
            <div className="section-1 bg-white">
            <div className="row">
                <div class="col-md-5 d-flex">
                <div class="section-image my-auto">
                    <img src="/assets/toyota-hhc.png" className="w-100" alt="Toyota HHC Logo" />
                </div>
                </div>
                <div className="col-md-7">
                <div className="section-content">
                    <p className="text-center" style={{fontSize:'1.2rem'}}>
                    Gratis pemeriksaan baterai Hybrid di bengkel<br/>
                    resmi Toyota minimum tahun ke-3 atau masuk<br/>
                    servis ke-6 / 50.000 Km
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div id="hhcBenefits" className="container px-lg-5">
            <h2 className='text-center fw-bold text-blue-hybrid my-3'>BENEFIT</h2>
            <div id="benefitContainer">
            <div className='benefit-item-button'>
                <img src="/assets/hhc-icon-service-schedule.png" />
                <p>Cek Baterai Gratis Setiap Servis Berkala di Bengkel Resmi Toyota*</p>
            </div>
            <div className='benefit-item-button'>
                <img src="/assets/hhc-icon-battery-warranty.png" />
                <p>Garansi Baterai Hingga 8 Tahun</p>
            </div>
            <div className='benefit-item-button'>
                <img src="/assets/hhc-icon-certified-battery.png" />
                <p>Kondisi Baterai yang Tersertifikasi</p>
            </div>
            </div>
        </div>

        <div id="hhcModels" className="container-fluid my-5">
            <h2 className='text-center fw-bold text-blue-hybrid my-3'>Model Coverage</h2>
            <Slider {...carSliderSettings}>
            {cars.map((car, index) => (
                <div key={index} className="car-item-wrapper">
                <div className="car-item">
                    <img src={car.image} alt={car.name} />
                    <h4 className='text-blue-hybrid fw-bold'>{car.type}</h4>
                    <p>{car.name}</p>
                </div>
                </div>
            ))}
            </Slider>
        </div>

        <div id="hhcTerms" className="container px-lg-5 my-5">
            <h2 className='text-center fw-bold text-blue-hybrid my-3'>Terms & Condition</h2>
            <div id='hhcTermsList'>
            <div className='hhc-terms-item'>
                <div className='hhc-terms-number me-2 text-blue-hybrid'>1</div>
                <p className='hhc-terms-content'>Pelanggan GBSB & T-CARE yang sudah memasuki <b>masa kepemilikan tahun ke-3</b> dari bulan Delivery <b>(min. servis ke-6 / 50.000 Km)</b> setiap 6 bulan sampai maksimum <b>tahun ke-5</b> atau <b>100.000 Km</b></p>
            </div>
            <div className='hhc-terms-item'>
                <div className='hhc-terms-number me-2 text-blue-hybrid'>2</div>
                <p className='hhc-terms-content'><b>Benefit Hybrid Health Check hanya dapat digunakan</b> jika pelanggan melakukan <b>servis berkala (SBE)</b></p>
            </div>
            <div className='hhc-terms-item'>
                <div className='hhc-terms-number me-2 text-blue-hybrid'>3</div>
                <p className='hhc-terms-content'>Pelanggan akan <b>menerima sertifikat hasil pengecekan Kesehatan Baterai EV</b> saat proses <b>delivery setelah servis berlangsung</b></p>
            </div>
            <div className='hhc-terms-item'>
                <div className='hhc-terms-number me-2 text-blue-hybrid'>4</div>
                <p className='hhc-terms-content'>Jika hasil dari pengecekan adalah <b>"Not Good" dealer servis akan melakukan validasi dan menginformasikan cakupan warranty kepada customer</b></p>
            </div>
            </div>
        </div>

        <div className="container p-lg-5 mt-5">
          <h2 className="fw-bold">
            Lihat hal-hal yang sering ditanyakan
          </h2>
          <div className="mt-5">
            <NavLink to="/faq" className="btn custom-btn-hybrid fw-bold px-3 py-2">
              Go to FAQ Page
            </NavLink>
          </div>
        </div>

        <div className="container mt-3 mb-5">
          <div className="logos d-flex justify-content-center mt-3 mb-4">
            <div className="bottom-logo mx-2">
              <img src="/assets/quality-service.png" alt="t-care-img" />
            </div>
            <div className="bottom-logo mx-2">
              <img src="/assets/genuine-parts (1).png" alt="t-care-img" />
            </div>
            <div className="bottom-logo mx-2">
              <img src="/assets/itfe.png" alt="itfe-img" />
            </div>
          </div>
        </div>

      </div>
      <AftersalesExploreService showItem={[0,1,2,3,5,6]} />
      <Footer footerTheme={'toyota-hybrid'}></Footer>
    </div>
  );
}

function PrevArrow({ className, onClick }) {
  return (
    <div className={`${className} custom-arrow left`} onClick={onClick}>
      <img src="/assets/hybrid-arrow-left.png" />
    </div>
  );
}

function NextArrow({ className, onClick }) {
  return (
    <div className={`${className} custom-arrow right`} onClick={onClick}>
      <img src="/assets/hybrid-arrow-right.png" />
    </div>
  );
}

export default EVHCInfo;
